/* Won Jobs search filters reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';

export interface ISearchFiltersWonJobsState {
    filterMode: any;    
}

const initialState: ISearchFiltersWonJobsState = {    
    filterMode: 1,    
};

export function searchFiltersWonJobsReducer(state: ISearchFiltersWonJobsState = initialState, action: any): ISearchFiltersWonJobsState {
    switch (action.type) {        
        case Actions.SEARCH_WON_JOBS_FILTER_MODE:
            // console.log('Actions.SEARCH_WON_JOBS_FILTER_MODE:');
            return _.merge({}, state, { filterMode: action.value });        
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersWonJobsReducer.tsx